import React from 'react';
import RadioButtons from '../../Form/RadioButtons/RadioButtons';

/** @import {ValueType} from 'react-select' */
/** @import {OptionType} from '../../Form/Select/SelectTypes' */

const LivedAt = (/** @type {{ onChange: (value: ValueType<OptionType, false>) => void; disabled: boolean; livedAt: string; }} */ { onChange, livedAt, disabled }) => (
  <>
    <p className='form-step__message'>How long have you lived at this address?</p>

    <div className='form-step__row'>
      <RadioButtons
        name='livedAt'
        options={[
          { label: 'Less than 6 months', value: 'less_than_six' },
          { label: 'More than 6 months', value: 'more_than_six' }
        ]}
        onChange={onChange}
        disabled={disabled}
        value={livedAt}
      />
    </div>
  </>
);

export default LivedAt;
